<div class="content-no-data">
  <ng-content></ng-content>
</div>
